export function getVersion(): string {
    return __APP_VERSION__;
}
